import { CHAT_STATE } from "./constants";

export const isChatOpen = (state: CHAT_STATE) => state === CHAT_STATE.OPEN;
export const isChatStart = (state: CHAT_STATE) => state === CHAT_STATE.START;
export const isChatHide = (state: CHAT_STATE) => state === CHAT_STATE.HIDE;
export const isChatNotInit = (state: CHAT_STATE) =>
  state === CHAT_STATE.NOT_INIT;
